/**
 * Free-shipping progress in bag (drawer + optional cart summary). Syncs on cart:update.
 */
(function () {
  var CURRENCY_DECIMALS = { BHD: 3, BIF: 0, CLP: 0, JPY: 0, KMF: 0, KRW: 0, VND: 0, XPF: 0 };
  var DEFAULT_DECIMALS = 2;

  function cartJsUrl() {
    try {
      var t = window.Theme;
      if (t && t.routes && t.routes.cart_js_url) return t.routes.cart_js_url;
    } catch (e) {}
    return '/cart.js';
  }

  function formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision, divisor) {
    var roundedNumber = (moneyValue / divisor).toFixed(precision);
    var parts = roundedNumber.split('.');
    var a = parts[0] || '0';
    var b = parts[1] || '';
    a = a.replace(/\d(?=(\d\d\d)+(?!\d))/g, function (digit) {
      return digit + thousandsSeparator;
    });
    return precision <= 0 ? a : a + decimalSeparator + b.padEnd(precision, '0');
  }

  function formatMoney(moneyValue, format, currency) {
    if (!format || typeof format !== 'string') {
      return '$' + (moneyValue / 100).toFixed(2);
    }
    var cur = (currency || 'USD').toUpperCase();
    var currencyPrecision = CURRENCY_DECIMALS[cur] != null ? CURRENCY_DECIMALS[cur] : DEFAULT_DECIMALS;
    var divisor = Math.pow(10, currencyPrecision);

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, placeholder) {
      if (placeholder === 'currency') return currency || 'USD';
      var thousandsSeparator = ',';
      var decimalSeparator = '.';
      var precision = currencyPrecision;
      switch (placeholder) {
        case 'amount':
          break;
        case 'amount_no_decimals':
          precision = 0;
          break;
        case 'amount_with_comma_separator':
          thousandsSeparator = '.';
          decimalSeparator = ',';
          break;
        case 'amount_no_decimals_with_comma_separator':
          thousandsSeparator = '.';
          precision = 0;
          break;
        case 'amount_no_decimals_with_space_separator':
          thousandsSeparator = ' ';
          precision = 0;
          break;
        case 'amount_with_space_separator':
          thousandsSeparator = ' ';
          decimalSeparator = ',';
          break;
        case 'amount_with_period_and_space_separator':
          thousandsSeparator = ' ';
          decimalSeparator = '.';
          break;
        case 'amount_with_apostrophe_separator':
          thousandsSeparator = "'";
          decimalSeparator = '.';
          break;
        default:
          break;
      }
      return formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision, divisor);
    });
  }

  function syncRoot(root) {
    var thresholdCents = Number(root.dataset.thresholdCents || '0');
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var currency = root.dataset.currency || 'USD';

    var progressEl = root.querySelector('[data-mnj-fn-progress]');
    var qualifiedEl = root.querySelector('[data-mnj-fn-qualified]');
    var remainingEl = root.querySelector('[data-mnj-fn-remaining]');
    var fillEl = root.querySelector('[data-mnj-fn-fill]');
    var trackEl = root.querySelector('[data-mnj-fn-track]');

    if (!progressEl || !qualifiedEl) return;

    function applyQualified(isQualified) {
      qualifiedEl.hidden = !isQualified;
      progressEl.hidden = isQualified;
    }

    fetch(cartJsUrl(), { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (cart) {
        if (!cart) return;
        var total = typeof cart.total_price === 'number' ? cart.total_price : 0;
        var cur = (cart.currency && cart.currency.iso_code) || currency;

        if (thresholdCents <= 0) {
          applyQualified(true);
          return;
        }

        var remaining = Math.max(0, thresholdCents - total);
        var pct = Math.min(100, Math.round((total / thresholdCents) * 100));

        if (remaining === 0) {
          applyQualified(true);
        } else {
          applyQualified(false);
          if (remainingEl) remainingEl.textContent = formatMoney(remaining, moneyFormat, cur);
          if (fillEl) fillEl.style.width = pct + '%';
          if (trackEl) trackEl.setAttribute('aria-valuenow', String(pct));
        }
      })
      .catch(function () {});
  }

  function syncAll() {
    document.querySelectorAll('[data-mnj-fn-cart-ship-root]').forEach(syncRoot);
  }

  if (!window.__mnjFnCartShipInit) {
    window.__mnjFnCartShipInit = true;
    document.addEventListener('cart:update', syncAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }
})();
